module.exports = __webpack_public_path__ + "i18n/de.1b958af6a4b8b9658855bc1906705eec.json";


//////////////////
// WEBPACK FOOTER
// ./node_modules/file-loader/dist/cjs.js?name=i18n/[name].[hash].[ext]!./i18n/de.json
// module id = 1853
// module chunks = 0